import React from 'react';
import {
  Subtitle,
  Content,
  DetailContent,
  PlanContent,
  IconAlert,
  IconNext,
  DivIconNext,
  NotPayment,
  Badges,
} from './styles';
import formatPrice from '../../services/utils/formatPrice';
import { BiCalendar } from 'react-icons/bi';
import { BsFillTagFill } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';
import Badge from '../Badge';
import { FaCreditCard } from 'react-icons/fa';
import { useSelector } from 'react-redux';

interface NegotiationListProps {
  list: GQL.IOption[];
  contract: GQL.IDebt;
}

const NegotiationList = ({ list, contract }: NegotiationListProps) => {
  const history = useHistory();
  const { bestOptionText } = useSelector((state: ApplicationState) => ({
    bestOptionText: state.config.textoMelhorOpcao,
  }));

  const formatType = (type: string) => {
    if (type === 'Quitacao') return 'Quitação';
    else if (type === 'Renegociacao') return 'Renegociação';
    else {
      return 'Atualização';
    }
  };
  const abstract = (negotiation: GQL.IOption) => {
    history.push({
      pathname: '/resumo-negociacao',
      state: { contract, negotiation },
    });
  };

  return (
    <>
      {list.length > 0 && list[0].plan && list[0].plan >= 1 ? (
        <>
          {list.map((negotiation, index) => (
            <Content key={index} onClick={() => abstract(negotiation)}>
              <PlanContent className='mobile-1'>
                <span>{negotiation.plan}x</span>
              </PlanContent>
              <DetailContent className='mobile-2'>
                <div className='contentText'>
                  <span className={'spanContent'}>
                    {negotiation.plan === 1 ? 'À Vista' : 'Entrada de'}
                  </span>
                  <Subtitle>
                    R${' '}
                    {formatPrice(
                      negotiation.firstPortionValue
                        ? negotiation.firstPortionValue
                        : 0
                    )}
                  </Subtitle>
                  {negotiation.plan && negotiation.plan !== 1 && (
                    <div className='default2'>
                      <span>
                        + {negotiation.plan && negotiation.plan - 1} parcelas de
                        R$
                        {formatPrice(
                          negotiation.othersPortionsValue
                            ? negotiation.othersPortionsValue
                            : 0
                        )}
                      </span>
                    </div>
                  )}
                  <div className='contentInfo'>
                    <div style={{ display: 'flex' }}>
                      <BsFillTagFill className='space-right' />
                      <span>Tipo:</span>{' '}
                      <strong className='space-left'>
                        {' '}
                        {formatType(
                          negotiation.negotiationTypeDescription || ''
                        )}
                      </strong>
                      <span className='space-right space-left'> | </span>
                    </div>
                    <div style={{ display: 'flex' }}>
                      <BiCalendar className='space-right' />
                      <span>Vencimento:</span>{' '}
                      <strong className='space-left'>
                        {negotiation.formatedDueDate}
                      </strong>
                      {negotiation.paymentMethod !== null && (
                        <span className='space-right space-left'> | </span>
                      )}
                    </div>
                    {negotiation.paymentMethod !== null && (
                      <div style={{ display: 'flex' }}>
                        <FaCreditCard className='space-right' />
                        Forma de pagamento:{' '}
                        <strong className='space-left'>
                          {negotiation.paymentMethod}
                        </strong>
                      </div>
                    )}
                  </div>
                </div>
              </DetailContent>

              <Badges className='mobile-4'>
                {negotiation.isBestInstallment && (
                  <Badge>
                    <span
                      className={
                        window.innerWidth <= 960 ? 'mobile-spacing' : ''
                      }
                      style={{ fontSize: '16px' }}
                    >
                      {bestOptionText ? bestOptionText : 'melhor opção'}
                    </span>
                  </Badge>
                )}

                {negotiation.discountPercentage && (
                  <Badge>
                    <span
                      className={window.innerWidth <= 960 ? 'text-mobile' : ''}
                      style={{
                        fontSize: '9px',
                        fontWeight: 400,
                        lineHeight: '14px',
                      }}
                    >
                      desconto até
                    </span>
                    <span
                      className={
                        window.innerWidth <= 960 ? 'percent-mobile' : ''
                      }
                      style={{
                        fontSize: '19px',
                        fontWeight: 700,
                        lineHeight: '19px',
                      }}
                    >
                      {negotiation.discountPercentage}
                    </span>
                  </Badge>
                )}
              </Badges>
              <DivIconNext className='mobile-3'>
                <IconNext />
              </DivIconNext>
            </Content>
          ))}
        </>
      ) : (
        <NotPayment>
          <IconAlert className='alert-icon' />
          <div className='box-notpayment'>
            <p className='title1'>
              Não possuímos nenhuma forma de negociação para esse débito!
            </p>
            <span className='title2'>
              Entre em contato nos canais abaixo para mais detalhes.
            </span>
            <div className='line'></div>
          </div>
        </NotPayment>
      )}
    </>
  );
};

export default NegotiationList;
